import { render, staticRenderFns } from "./Heart.vue?vue&type=template&id=5c3cf7cc&scoped=true&"
import script from "./Heart.vue?vue&type=script&lang=js&"
export * from "./Heart.vue?vue&type=script&lang=js&"
import style0 from "./Heart.vue?vue&type=style&index=0&id=5c3cf7cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3cf7cc",
  null
  
)

component.options.__file = "Heart.vue"
export default component.exports